export const urls = Object.freeze({
    GET_GLOBAL_CONFIGS: '/api/get_global_conf/',
    SET_GLOBAL_CONFIGS: '/api/set_global_conf/',
    SAVE_CAP_REPORT: '/api/save_cap_report/'
})